import { i18n } from './i18n.js';

/* Muchos paneles dan el género en inglés ("Action", "Sci-Fi & Fantasy") aunque la app esté en
   español. Aquí se traducen los habituales; lo que no se conoce se deja como viene. */

const ES = {
    action: 'Acción', adventure: 'Aventura', animation: 'Animación', anime: 'Anime', biography: 'Biografía',
    comedy: 'Comedia', crime: 'Crimen', documentary: 'Documental', drama: 'Drama', family: 'Familia',
    fantasy: 'Fantasía', history: 'Historia', horror: 'Terror', kids: 'Infantil', music: 'Música',
    musical: 'Musical', mystery: 'Misterio', news: 'Noticias', reality: 'Telerrealidad', romance: 'Romance',
    'science fiction': 'Ciencia ficción', 'sci-fi': 'Ciencia ficción', 'sci fi': 'Ciencia ficción', scifi: 'Ciencia ficción',
    soap: 'Telenovela', sport: 'Deportes', sports: 'Deportes', talk: 'Entrevistas', thriller: 'Suspense',
    'tv movie': 'Película de TV', war: 'Bélica', western: 'Western', politics: 'Política'
};

function one(name) {
    const clean = String(name || '').trim();
    if (!clean || i18n.lang !== 'es') return clean;
    return ES[clean.toLowerCase()] || clean;
}

/** "Action, Sci-Fi & Fantasy" → ['Acción', 'Ciencia ficción', 'Fantasía'] (sin repetir). */
export function genreList(genre) {
    const out = [];
    String(genre || '').split(/[,/|;&]+/).forEach((part) => {
        const g = one(part);
        if (g && out.indexOf(g) === -1) out.push(g);
    });
    return out;
}

/** El primero, para las líneas de datos de tarjetas y cabeceras. */
export function firstGenre(genre) {
    return genreList(genre)[0] || '';
}
